"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const app_service_1 = require("./app.service");
const common_2 = require("@nestjs/common");
const auth_guard_1 = require("../../../service-lib/src/lib/auth.guard");
const acl_guard_1 = require("../../../service-lib/src/lib/acl.guard");
const axios_1 = tslib_1.__importDefault(require("axios"));
const environment_1 = require("../../../service-lib/src/lib/environment");
const constants_1 = require("../../../service-lib/src/lib/constants");
const stream_1 = require("stream");
let AppController = class AppController {
    constructor(appService) {
        this.appService = appService;
    }
    getData() {
        return this.appService.getData();
    }
    async registerService(serviceData) {
        try {
            const registeredData = await this.appService.registerService(serviceData);
            return registeredData;
        }
        catch (error) {
            throw new common_2.HttpException(error.message || "Service unavailable", error.status || common_2.HttpStatus.BAD_GATEWAY);
        }
    }
    async swaggerDocs(serviceName, request) {
        try {
            const serviceUrl = await this.appService.getServiceUrl(serviceName);
            const path = request.url.replace(`/${constants_1.iirm}/${serviceName}`, "");
            const username = environment_1.ENV.SWAGGER_USERNAME;
            const password = environment_1.ENV.SWAGGER_PASSWORD;
            const Authorization = `Basic ${Buffer.from(`${username}:${password}`).toString("base64")}`;
            const response = await axios_1.default.get(`${serviceUrl}${path}`, {
                headers: {
                    Authorization: Authorization,
                },
            });
            response.data = response.data.replace(/href="\.\/docs\/swagger-ui\.css"/g, `href="${environment_1.ENV.URL_API_GATEWAY}/api/docs/swagger-ui.css"`);
            return response.data;
        }
        catch (error) {
            const statusCode = error.response?.status || common_2.HttpStatus.BAD_GATEWAY;
            const responseData = error.response?.data;
            if (responseData) {
                throw new common_2.HttpException(responseData, statusCode);
            }
            throw new common_2.HttpException({
                statusCode,
                message: error.message || "Service unavailable",
            }, statusCode);
        }
    }
    async fileUpload(serviceName, request, response) {
        try {
            const headers = { ...request.headers };
            const serviceUrl = await this.appService.getServiceUrl(serviceName);
            const path = request.url.replace(`/${constants_1.iirm}/${serviceName}`, "");
            const targetUrl = `${serviceUrl}${path}`;
            // Inject userId into headers if available
            if (request.user?.userDetails?.userId) {
                headers["userid"] = String(request.user.userDetails.userId);
            }
            // Remove content-length because we are re-streaming
            delete headers["content-length"];
            delete headers["host"];
            // Create a pass-through stream to forward the request body
            const passthrough = new stream_1.PassThrough();
            request.pipe(passthrough);
            const axiosResponse = await (0, axios_1.default)({
                method: request.method,
                url: targetUrl,
                headers,
                data: passthrough,
                responseType: "stream",
                maxContentLength: Infinity,
                maxBodyLength: Infinity,
                validateStatus: () => true, // allow non-2xx
            });
            // Set response headers and status
            response.status(axiosResponse.status);
            for (const [key, value] of Object.entries(axiosResponse.headers)) {
                if (value) {
                    response.setHeader(key, value.toString());
                }
            }
            // Pipe the response stream to the client
            axiosResponse.data.pipe(response);
        }
        catch (error) {
            const statusCode = error.response?.status || common_2.HttpStatus.BAD_GATEWAY;
            const responseData = error.response?.data;
            if (responseData) {
                throw new common_2.HttpException(responseData, statusCode);
            }
            throw new common_2.HttpException({
                statusCode,
                message: error.message || "Service unavailable",
            }, statusCode);
        }
    }
    async proxyFileDownload(serviceName, documentId, req, res) {
        try {
            const serviceUrl = await this.appService.getServiceUrl(serviceName);
            const downloadUrl = `${serviceUrl}/knowledge/${documentId}/download`;
            const { host, "content-length": _, ...safeHeaders } = req.headers;
            // Attach user ID header if available
            if (req.user) {
                safeHeaders["userid"] = req.user.userDetails.userId;
            }
            // Perform streaming request to the microservice
            const response = await axios_1.default.get(downloadUrl, {
                responseType: "stream",
                headers: safeHeaders,
            });
            // Pipe all headers from the microservice response
            Object.entries(response.headers).forEach(([key, value]) => {
                res.setHeader(key, value);
            });
            // Pipe the response stream to client
            response.data.pipe(res);
        }
        catch (error) {
            const statusCode = error.response?.status || common_2.HttpStatus.BAD_GATEWAY;
            const responseData = error.response?.data;
            if (responseData &&
                error.response?.headers?.["content-type"]?.includes("application/json")) {
                res.status(statusCode).json(responseData);
            }
            else {
                res
                    .status(statusCode)
                    .send(responseData || "Failed to download file from downstream service");
            }
        }
    }
    async knowledgeCentralFileUpload(serviceName, request, response) {
        try {
            const headers = { ...request.headers };
            const serviceUrl = await this.appService.getServiceUrl(serviceName);
            const path = request.url.replace(`/${constants_1.iirm}/${serviceName}`, "");
            const targetUrl = `${serviceUrl}${path}`;
            // Inject userId into headers if available
            if (request.user?.userDetails?.userId) {
                headers["userid"] = String(request.user.userDetails.userId);
            }
            // Remove content-length because we are re-streaming
            delete headers["content-length"];
            delete headers["host"];
            // Create a pass-through stream to forward the request body
            const passthrough = new stream_1.PassThrough();
            request.pipe(passthrough);
            const axiosResponse = await (0, axios_1.default)({
                method: request.method,
                url: targetUrl,
                headers,
                data: passthrough,
                responseType: "stream",
                maxContentLength: Infinity,
                maxBodyLength: Infinity,
                validateStatus: () => true, // allow non-2xx
            });
            // Set response headers and status
            response.status(axiosResponse.status);
            for (const [key, value] of Object.entries(axiosResponse.headers)) {
                if (value) {
                    response.setHeader(key, value.toString());
                }
            }
            // Pipe the response stream to the client
            axiosResponse.data.pipe(response);
        }
        catch (error) {
            const statusCode = error.response?.status || common_2.HttpStatus.BAD_GATEWAY;
            const responseData = error.response?.data;
            if (responseData) {
                throw new common_2.HttpException(responseData, statusCode);
            }
            throw new common_2.HttpException({
                statusCode,
                message: error.message || "Service unavailable",
            }, statusCode);
        }
    }
    async proxyRequest(serviceName, request) {
        try {
            const serviceUrl = await this.appService.getServiceUrl(serviceName);
            const path = request.url.replace(`/${constants_1.iirm}/${serviceName}`, "");
            const targetUrl = `${serviceUrl}${path}`;
            const { host, "content-length": _, ...safeHeaders } = request.headers;
            if (request.user) {
                safeHeaders["userid"] = request.user.userDetails.userId;
            }
            const response = await (0, axios_1.default)({
                method: request.method,
                url: targetUrl,
                data: request.body,
                headers: {
                    ...safeHeaders,
                },
            });
            return response.data;
        }
        catch (error) {
            const statusCode = error.response?.status || common_2.HttpStatus.BAD_GATEWAY;
            const responseData = error.response?.data;
            if (responseData) {
                throw new common_2.HttpException(responseData, statusCode);
            }
            throw new common_2.HttpException({
                statusCode,
                message: error.message || "Service unavailable",
            }, statusCode);
        }
    }
};
exports.AppController = AppController;
tslib_1.__decorate([
    (0, common_1.Get)(),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], AppController.prototype, "getData", null);
tslib_1.__decorate([
    (0, common_1.Post)("register"),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", Promise)
], AppController.prototype, "registerService", null);
tslib_1.__decorate([
    (0, common_1.Get)(":service/api/docs*"),
    tslib_1.__param(0, (0, common_2.Param)("service")),
    tslib_1.__param(1, (0, common_2.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], AppController.prototype, "swaggerDocs", null);
tslib_1.__decorate([
    (0, common_2.All)(":service/file-upload/upload*"),
    (0, common_1.UseGuards)(auth_guard_1.AuthGuard, acl_guard_1.AclGuard),
    tslib_1.__param(0, (0, common_2.Param)("service")),
    tslib_1.__param(1, (0, common_2.Req)()),
    tslib_1.__param(2, (0, common_2.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], AppController.prototype, "fileUpload", null);
tslib_1.__decorate([
    (0, common_1.Get)(":service/knowledge/:documentId/download"),
    (0, common_1.UseGuards)(auth_guard_1.AuthGuard, acl_guard_1.AclGuard),
    tslib_1.__param(0, (0, common_2.Param)("service")),
    tslib_1.__param(1, (0, common_2.Param)("documentId")),
    tslib_1.__param(2, (0, common_2.Req)()),
    tslib_1.__param(3, (0, common_2.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, BigInt, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], AppController.prototype, "proxyFileDownload", null);
tslib_1.__decorate([
    (0, common_2.All)(":service/knowledge/file*"),
    (0, common_1.UseGuards)(auth_guard_1.AuthGuard, acl_guard_1.AclGuard),
    tslib_1.__param(0, (0, common_2.Param)("service")),
    tslib_1.__param(1, (0, common_2.Req)()),
    tslib_1.__param(2, (0, common_2.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], AppController.prototype, "knowledgeCentralFileUpload", null);
tslib_1.__decorate([
    (0, common_2.All)(":service/*"),
    (0, common_1.UseGuards)(auth_guard_1.AuthGuard, acl_guard_1.AclGuard),
    tslib_1.__param(0, (0, common_2.Param)("service")),
    tslib_1.__param(1, (0, common_2.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], AppController.prototype, "proxyRequest", null);
exports.AppController = AppController = tslib_1.__decorate([
    (0, common_1.Controller)("iirm"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof app_service_1.AppService !== "undefined" && app_service_1.AppService) === "function" ? _a : Object])
], AppController);
